import { i18n } from "../translate/i18n";

const adjustTicketTimeNumber = (timeAwaitingNumber, timeAwaitingMetric) => {
  const hourMetrics = [i18n.t("ticketsList.timeAwaitHour"), i18n.t("ticketsList.timeAwaitHour") + "s"];
  const dayMetrics = [i18n.t("ticketsList.timeAwaitDay"), i18n.t("ticketsList.timeAwaitDay") + "s"];

  if (dayMetrics.includes(timeAwaitingMetric)) timeAwaitingNumber = timeAwaitingNumber * 60 * 24;
  else if (hourMetrics.includes(timeAwaitingMetric)) timeAwaitingNumber = timeAwaitingNumber * 60;

  return timeAwaitingNumber;
};

export default adjustTicketTimeNumber;
